import moment from 'moment';
import { useEffect, useState } from 'react';
import { useCurrentMemberContext } from 'src/contexts';
import { getMonthlyWorkload } from 'src/pages/dashboard/components/widgets/widgets.helpers';
import { IGanttRecord, IWorkloadList } from 'src/pages/dashboard/dasboard.interfaces';
import { useGetGanttRecordsByRangeForActiveGantt } from '../gantts-records/get-gantt-records-by-range.hook';
import { useGetAssignedTimeStripesForActiveGantt } from '../time-stripes/get-time-stripes.hook';
import { useGetAllWorkingHoursByCurrentGantt } from '../employees/get-gantt-employees-working-hours.hook';

export const useGetEmployeeWorkload = (startDate: Date, endDate: Date, year: number) => {
  const [workloadRecords, setWorkloadRecords] = useState<IWorkloadList[]>([]);
  const [prevYear, setPrevYear] = useState<number>(year);

  const { ganttRecords, loading } = useGetGanttRecordsByRangeForActiveGantt({ startDate, endDate });
  const { timeStripes } = useGetAssignedTimeStripesForActiveGantt({ startDate, endDate });
  const { employeesWorkingHours } = useGetAllWorkingHoursByCurrentGantt();
  const { ganttId } = useCurrentMemberContext();

  const [prevGanttId, setPrevGanttId] = useState(ganttId);

  const monthlyWorkload = getMonthlyWorkload(
    workloadRecords,
    timeStripes,
    employeesWorkingHours,
    year
  );

  const resetWorkloadList = () => {
    setWorkloadRecords([]);
  };

  const total = ganttRecords.length;

  useEffect(() => {
    if (ganttId !== prevGanttId) {
      resetWorkloadList();
    }
  }, [ganttId, prevGanttId]);

  useEffect(() => {
    if (year !== prevYear) {
      resetWorkloadList();
    }
  }, [year, prevYear]);

  useEffect(() => {
    if (total > 0) {
      ganttRecords.forEach((record: IGanttRecord) => {
        setWorkloadRecords(prev => [
          ...prev,
          {
            planned: record.plannedRecordHours,
            entries: record.entries,
            date: moment(record.date),
          },
        ]);
        setPrevYear(year);
        setPrevGanttId(ganttId);
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [total]);

  return {
    monthlyWorkload,
    total,
    loading,
  };
};
